import AlertComponent from '@components/modal/Alert.component';
import {Button} from '@mui/material';
import {invoicesService, SendInvoiceForMailing, SendInvoiceType} from '@store/invoices/invoices';
import {useSnackbar} from 'notistack';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {finalize} from 'rxjs';

export interface ConfirmSendMailModalProps {
  handleClose: () => void;
  handleSuccess: () => void;
  invoices: SendInvoiceForMailing[];
  sendInvoiceType: SendInvoiceType;
}

const ConfirmSendMailModal = (props: ConfirmSendMailModalProps) => {
  const {handleClose, handleSuccess, invoices, sendInvoiceType} = props;

  const {enqueueSnackbar} = useSnackbar();
  const {t} = useTranslation();

  const [loading, setLoading] = useState(false);

  const handleValidate = () => {
    if (!invoices.length) return;

    setLoading(true);
    invoicesService.sendInvoices(invoices, sendInvoiceType).pipe(finalize(() => setLoading(false))).subscribe({
      next: () => {
        enqueueSnackbar(t('invoices.bills.mailing.success.sent'), {variant: 'success'});
        handleSuccess();
      },
      error: (err) => enqueueSnackbar(err.text, err.options),
    });
  };

  return (
    <AlertComponent
      title={t('invoices.bills.mailing.confirm.title')}
      description={t('invoices.bills.mailing.confirm.description')}
      handleClose={handleClose}
      actions={(
        <>
          <Button variant="outlined" color="primary" disabled={loading} onClick={handleClose}>
            {t('global.cancel')}
          </Button>
          <Button variant="contained" disabled={loading} color="primary" onClick={handleValidate}>
            {t('global.validate')}
          </Button>
        </>
      )}/>
  );
};

export default ConfirmSendMailModal;
